module.exports = __webpack_public_path__ + "static/media/icon_file.b89a5574.svg";